<template>
  <div class="wrapper">
    <div class="table">
      <vxe-grid border stripe resizable auto-resize :columns="tableColumn" :data="tableData" :loading="loading">
        <template v-slot:status="{ row }">
          <span>{{ reversalStatus(row) }}</span>
        </template>
      </vxe-grid>
      <vxe-pager
        :current-page.sync="tablePage.currentPage"
        :page-size.sync="tablePage.pageSize"
        :page-sizes="tablePage.pageSizes"
        :total="tablePage.totalResult"
        :layouts="layouts"
        @page-change="pageChange"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      seachStatus: false,
      searchData: {},
      homeServRecdStatusLst: [],
      // 分页的参数配置
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true,
      },
      tableColumn: [
        {
          type: 'seq',
          title: '序号',
          width: 50,
          align: 'center',
        },
        {
          field: 'name',
          title: '服务对象',
          showOverflow: true,
          align: 'center',
          minWidth: '120',
        },
        {
          field: 'status',
          title: '订单状态',
          showOverflow: true,
          align: 'center',
          minWidth: '120',
          slots: {
            default: 'status',
          },
        },
        {
          field: 'serviceItem',
          title: '服务项目',
          showOverflow: true,
          align: 'center',
          minWidth: '120'
        },
        {
          field: 'satisfaction',
          title: '满意度',
          showOverflow: true,
          align: 'center',
          minWidth: '120'
        },
        {
          field: 'address',
          title: '服务区域（地址）',
          showOverflow: true,
          align: 'center',
          minWidth: '120'
        }
      ],
      tableData: [],
    }
  },
  computed: {
    ...mapState(['layouts']),
    ...mapGetters(['seqId']),
  },
  watch: {
    seqId() {
      // this.getLists()
    },
  },
  created() {
    this.initView()
    this.getDicList()
  },
  methods: {
    ...mapActions(['getServeRecordsListServe', 'deleteServiceRecord', 'getSysDictServe']),
    initView() {
      this.getLists()
    },
    goPage(type, itemData) {
      this.$router.push({
        name: 'AddServiceRecord',
        params: {
          type: type,
          id: type == 'add' ? 'add' : itemData.id,
          serviceOrgId: this.$route.params.id,
        },
        query: {
          item: type == 'add' ? 'add' : JSON.stringify(itemData),
          source: this.$route.query.type
        },
      })
    },
    getDicList() {
      this.getSysDictList('homeServRecdStatus', 'homeServRecdStatusLst')
    },
    // 获取数据字典
    getSysDictList(code, codeList) {
      let params = {
        typeCode: code,
      }
      this.getSysDictServe(params).then((res) => {
        if (res.code == 200) {
          this[codeList] = res.data
        }
      })
    },
    getLists() {
      this.loading = true
      this.getServeRecordsListServe({
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        param: {
          workPersonId: this.$route.params.id,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.records
          this.tablePage.totalResult = +res.data.total
        }
        this.loading = false
      })
    },
    // 分页功能
    pageChange(item) {
      if (item.type == 'size') {
        this.tablePage.currentPage = 1
      } else {
        this.tablePage.currentPage = item.currentPage
      }
      this.getLists()
    },
    searchEvent() {
      console.log(this.searchData)
      this.seachStatus = false
      this.getLists()
    },
    searchReset() {
      this.searchData = {}
      this.getLists()
    },
    reversalStatus(row) {
      let msg = row.status
      for (let i = 0; i < this.homeServRecdStatusLst.length; i++) {
        if (row.status === this.homeServRecdStatusLst[i].dictPidVal) {
          msg = this.homeServRecdStatusLst[i].dictDesc
        }
      }
      return msg
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  overflow-y: auto;
}
.wrapper {
  .datetime {
    display: flex;
    align-items: center;
    span {
      margin: 0 3px;
    }
  }
}
.sign i {
  margin-right: 3px;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
